import React, { ReactNode, useRef } from 'react';
import { AnimationContainer } from 'elements/animation/fade-in/FadeInAnimationWrapper.styles';
import useOnVisible from 'src/hooks/useOnVisible';

interface FadeInAnimationWrapperProps {
  readonly transitionTimeSeconds?: number;
  readonly style?: React.CSSProperties;
  readonly id?: string;
  readonly children?: ReactNode;
  readonly delayTime?: number;
}

// TODO: Remove style prop when migrate the component to CSS Modules
const FadeInAnimationWrapper = ({
  transitionTimeSeconds = 1,
  style,
  children,
  id,
  delayTime = 0,
}: FadeInAnimationWrapperProps): JSX.Element => {
  const elementRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnVisible(elementRef, 0.5);

  return (
    <AnimationContainer
      isVisible={isVisible}
      transitionTimeSeconds={transitionTimeSeconds}
      transitionDelay={delayTime}
      ref={elementRef}
      style={style}
      id={id}
      className='fade-in-animation-wrapper'
    >
      {children}
    </AnimationContainer>
  );
};

export default FadeInAnimationWrapper;
